import { http } from "../infrastructure/Https";
import tokenService from "../services/TokenService";
import { ReferralReportType } from "../types/reportingTypes";
const ROOT_URL = "/api/v1/reporting";


class ReportingApi {
  //для отправки сведений о клике по реферальной ссылке.
  async postReferralReport(body: ReferralReportType): Promise<any> {
    const accessToken = tokenService.getAccessToken();
    try {
      const response = await http.post(`${ROOT_URL}/referral`, null, body, accessToken);
      return response;
    } catch (error) {
      console.error("Error posting referral report:", error);
      throw error;
    }
  }
}

const reportingApi = new ReportingApi();
export default reportingApi;
